import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import ConvertMeasurement from "../../../../components/Math/Conversion/ConvertMeasurement";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit";
import { ImperialUnits, MetricUnits } from "../../../../components/Math/Units/AllUnits";
import Foot from "../../../../components/Math/Units/Imperial/Foot";
import Inch from "../../../../components/Math/Units/Imperial/Inch";
import Kilopound from "../../../../components/Math/Units/Imperial/Kilopound";
import KiloNewton from "../../../../components/Math/Units/Metric/KiloNewton";
import KiloNewtonDividedByMetreSquared from "../../../../components/Math/Units/Metric/KiloNewtonDividedByMetreSquared";
import Metre from "../../../../components/Math/Units/Metric/Metre";
import Millimetre from "../../../../components/Math/Units/Metric/Millimetre";
import AlertBox from "../../../../components/Messages";
import { NumberFormatInfInput } from "../../../../components/NumberFormatInfInput";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import {
  CLAY_OR_ROCK,
  FOR_INS_WITH_EXT_JETTING,
  MEDIUM_AND_CORASE_GRAVEL,
  SAND_AND_SANDY_GRAVEL,
} from "../../../../constants";
import {
  addLayer,
  deleteLayer,
  selectAllInputLayers,
  selectLayersCalculated,
  selectSumLoadTakenInLayerTotal,
  selectTableUtilization,
  updateLayerValue,
} from "../../../../store/slices/fhwaSlice";
import {
  Measurements,
  selectIsImperial,
  selectIsMetric,
  selectMeasurementType,
} from "../../../../store/slices/settingsSlice";
import WideningInfo from "../../WideningInfo";
import PoundPerSquaredInch from "../../../../components/Math/Units/Imperial/PoundPerSquaredInch";

function OuterTable() {
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");

  const layersInput = useSelector(selectAllInputLayers);
  const layerCalculated = useSelector(selectLayersCalculated);

  const tableUtilization = useSelector(selectTableUtilization);
  const sumLoadTakenInLayer = useSelector(selectSumLoadTakenInLayerTotal);

  const isImperial = useSelector(selectIsImperial);
  const isMetric = useSelector(selectIsMetric);

  let borderUnitType = isMetric ? MetricUnits.Metre : isImperial ? ImperialUnits.Foot : null;

  let FrictionUnitType = isMetric
    ? MetricUnits.KiloNewtonDividedByMetreSquared
    : isImperial
      ? ImperialUnits.PoundPerSquaredInch
      : null;

  function addNewRowHandler() {
    let rows = Object.keys(layersInput).length;

    let bottomValue = 0;
    if (Number(rows) >= 1) {
      let index = rows - 1;
      let prevLayer = layersInput[index];
      bottomValue = prevLayer.layerBottom.current;
    }

    let newLayer = {
      index: rows,
      description: `Layer ${rows + 1}`,
      widening: CLAY_OR_ROCK,
      layerTop: { value: bottomValue, unit: borderUnitType },
      layerBottom: { value: Number.MAX_SAFE_INTEGER, unit: borderUnitType },
      skinFriction: { value: 0, unit: FrictionUnitType },
      factorOfSafety: 0,
    };

    dispatch(addLayer(newLayer));
  }

  function isutilizationToBig() {
    //INFO: Wunsch Aziz
    //INFO: Berechnungsfehler aussschliessen
    const local = Number(Number(tableUtilization).toFixed(2));
    return local > 1.0 || local < 3e-15;
  }

  const [showWideningInfo, setShowWideningInfo] = useState(false);

  return (
    <Row>
      <Col md={10}>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">
                <p style={{ wordBreak: "brake-word" }}>{t("aashto.ausser.Layer description")}</p>
              </th>
              <th scope="col">
                <p style={{ wordBreak: "brake-word" }}>{t("aashto.ausser.Widening")}</p>
                <p>
                  [<ConvertUnit Metric={<Millimetre />} Imperial={<Inch />} />]
                  <span onClick={() => setShowWideningInfo(true)}>
                    <br />
                    <PlusIcon size={15} />
                  </span>
                </p>
                <WideningInfo show={showWideningInfo} setShow={setShowWideningInfo} />
              </th>
              <th scope="col">
                <p style={{ wordBreak: "break-word" }}>{t("aashto.ausser.Layer top")}</p>
                <p>
                  [<ConvertUnit Metric={<Metre />} Imperial={<Foot />} />]
                </p>
              </th>
              <th scope="col">
                <p style={{ wordBreak: "break-word" }}>{t("aashto.ausser.Layer bottom")}</p>
                <p>
                  [<ConvertUnit Metric={<Metre />} Imperial={<Foot />} />]
                </p>
              </th>
              <th scope="col">
                <p style={{ wordBreak: "break-word" }}>{t("aashto.ausser.Inclined length")}</p>
                <p>
                  [<ConvertUnit Metric={<Metre />} Imperial={<Foot />} />]
                </p>
              </th>
              <th scope="col">
                <p style={{ wordBreak: "break-word" }}>{t("aashto.ausser.Skin friction")}</p>
                <p>
                  [
                  <ConvertUnit
                    Metric={<KiloNewtonDividedByMetreSquared />}
                    Imperial={<PoundPerSquaredInch />}
                  />
                  ]
                </p>
              </th>

              <th scope="col">
                <p style={{ wordBreak: "break-word" }}>{t("aashto.ausser.Factor of Safety")}</p>
              </th>
              <th scope="col">
                <p style={{ wordBreak: "break-word" }}>
                  {t("aashto.ausser.Allowable skin friction")}
                </p>
                <p>
                  [
                  <ConvertUnit
                    Metric={<KiloNewtonDividedByMetreSquared />}
                    Imperial={<PoundPerSquaredInch />}
                  />
                  ]
                </p>
              </th>

              <th scope="col">
                <p style={{ wordBreak: "break-word" }}>{t("aashto.ausser.Load taken in layer")}</p>
                <p>
                  [
                  <ConvertUnit Metric={<KiloNewton />} Imperial={<Kilopound />} />]
                </p>
              </th>
              <th scope="col">
                <p style={{ wordBreak: "break-word" }}>{t("aashto.ausser.action")}</p>
              </th>
            </tr>
            {/* <tr>
              <th></th>
            </tr> */}
          </thead>
          <tbody>
            {layersInput.map((row, index) => {
              return (
                <OuterTableRow
                  key={index}
                  index={index}
                  rowValuesInput={row}
                  rowValuesCalc={layerCalculated[index]}
                />
              );
            })}

            {/* Results: */}
            <tr>
              <td colSpan="7"> {/* 7x Empty */}</td>
              <td>
                <span>{t("aashto.inner.Total")}:</span>
              </td>
              <td>
                <span className="smallInput">
                  <NumberFormatText value={sumLoadTakenInLayer.current} decimalScale={2} />
                </span>
              </td>
              <td>
                <p>
                  [
                  <ConvertUnit Metric={<KiloNewton />} Imperial={<Kilopound />} />]
                </p>
              </td>
              {/* <td>Empty </td> */}
            </tr>
            <tr>
              <td colSpan="7">{/* 7x Empty */}</td>
              <td>
                <span>{t("aashto.inner.Utilization")}:</span>
              </td>
              <td>
                <span className={`smallInput ${isutilizationToBig() ? "red" : null}`}>
                  <NumberFormatText value={tableUtilization} decimalScale={2} />
                </span>
              </td>
              <td>{/* Empty */}</td>
            </tr>
          </tbody>
        </table>
        <AlertBox show={isutilizationToBig()} message={t("aeussre.addLayerErrorAashto")} />
        <Button variant="success" size="sm" onClick={addNewRowHandler}>
          {t("aeussre.addLayerButton")}
        </Button>
        <p className="mt-2">{t("aeussre.extraNote")}</p>
        <p>{t("aeussre.extraNote_2")}</p>
      </Col>
    </Row>
  );
}

export default OuterTable;

function RemoveButton({ index }) {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  return (
    <>
      {index != 0 ? (
        <Button
          variant="danger"
          size="sm"
          onClick={() => dispatch(deleteLayer({ position: index }))}
        >
          {t("aeussre.removeLayerButton")}
        </Button>
      ) : null}
    </>
  );
}

function OuterTableRow({ index, rowValuesInput, rowValuesCalc }) {
  const dispatch = useDispatch();

  const measurementType = useSelector(selectMeasurementType);

  const isImperial = useSelector(selectIsImperial);
  const isMetric = useSelector(selectIsMetric);

  let borderUnitType = isMetric ? MetricUnits.Metre : isImperial ? ImperialUnits.Foot : null;

  let FrictionUnitType = isMetric
    ? MetricUnits.KiloNewtonDividedByMetreSquared
    : isImperial
      ? ImperialUnits.PoundPerSquaredInch
      : null;

  const [mediumAndCoraseGravel, setMediumAndCoraseGravel] = useState(MEDIUM_AND_CORASE_GRAVEL);
  const [sandAndSandyGravel, setSandAndSandyGravel] = useState(SAND_AND_SANDY_GRAVEL);
  const [forInsWithExtJetting, setForInsWithExtJetting] = useState(FOR_INS_WITH_EXT_JETTING);
  const [clayOrRock, setClayOrRock] = useState(CLAY_OR_ROCK);
  const [unit, setUnit] = useState(ImperialUnits.Inch);

  useEffect(() => {
    let metric = MetricUnits.Millimetre;
    let imperial = ImperialUnits.Inch;

    if (measurementType === Measurements.METRIC) {
      setUnit(metric);
      setMediumAndCoraseGravel(
        ConvertMeasurement({
          userInput: MEDIUM_AND_CORASE_GRAVEL,
          from: imperial,
          to: metric,
        })
      );
      setSandAndSandyGravel(
        ConvertMeasurement({
          userInput: SAND_AND_SANDY_GRAVEL,
          from: imperial,
          to: metric,
        })
      );
      setForInsWithExtJetting(
        ConvertMeasurement({
          userInput: FOR_INS_WITH_EXT_JETTING,
          from: imperial,
          to: metric,
        })
      );
      setClayOrRock(
        ConvertMeasurement({
          userInput: CLAY_OR_ROCK,
          from: imperial,
          to: metric,
        })
      );
    }

    if (measurementType === Measurements.IMPERIAL) {
      setUnit(imperial);
      setMediumAndCoraseGravel(MEDIUM_AND_CORASE_GRAVEL);
      setSandAndSandyGravel(SAND_AND_SANDY_GRAVEL);
      setForInsWithExtJetting(FOR_INS_WITH_EXT_JETTING);
      setClayOrRock(CLAY_OR_ROCK);
    }
  }, [measurementType]);

  return (
    <tr>
      <td>
        <input
          type="text"
          className="change-inputTable"
          value={rowValuesInput?.description}
          name="description"
          onChange={(e) => {
            dispatch(updateLayerValue({ index: index, description: e.target.value }));
          }}
        />
      </td>
      <td>
        <select
          name="widening"
          className="change-inputTable"
          value={rowValuesInput?.widening?.current}
          onChange={(e) => {
            dispatch(
              updateLayerValue({
                index: index,
                widening: {
                  value: e.target.value,
                  unit: unit,
                },
              })
            );
          }}
        >
          <option value={mediumAndCoraseGravel}>{mediumAndCoraseGravel}</option>
          <option value={sandAndSandyGravel}>{sandAndSandyGravel}</option>
          <option value={forInsWithExtJetting}>{forInsWithExtJetting}</option>
          <option value={clayOrRock}>{clayOrRock}</option>
        </select>
      </td>
      <td>
        <NumberFormatInfInput
          index={index}
          value={rowValuesInput?.layerTop?.current}
          name="layerTop"
          defaultINF={0}
          updateValueCallback={function (value) {
            return updateLayerValue({
              index: index,
              layerTop: {
                value: value,
                unit: borderUnitType,
              },
            });
          }}
        />
      </td>
      <td>
        <NumberFormatInfInput
          index={index}
          value={rowValuesInput?.layerBottom?.current}
          name="layerBottom"
          updateValueCallback={function (value) {
            return updateLayerValue({
              index: index,
              layerBottom: {
                value: value,
                unit: borderUnitType,
              },
            });
          }}
        />
      </td>
      <td>
        <span name="inclinedLength" className="smallInput">
          <NumberFormatText
            value={rowValuesCalc?.inclinedLength?.current}
            decimalScale={2}
            prefix={"INF"}
          />
        </span>
      </td>
      <td>
        <NumberFormatInfInput
          index={index}
          value={rowValuesInput?.skinFriction?.current}
          name="skinFriction"
          prefix={""}
          updateValueCallback={function (value) {
            return updateLayerValue({
              index: index,
              skinFriction: {
                value: value,
                unit: FrictionUnitType,
              },
            });
          }}
        />
      </td>
      <td>
        <NumberFormatInfInput
          index={index}
          value={rowValuesInput?.factorOfSafety}
          name="factorOfSafety"
          prefix={""}
          updateValueCallback={function (value) {
            return updateLayerValue({
              index: index,
              factorOfSafety: value,
            });
          }}
        />
      </td>

      <td>
        <span name="allowableSkinFriction" className="smallInput">
          <NumberFormatText
            value={rowValuesCalc?.allowableSkinFriction?.current}
            decimalScale={2}
            prefix="INF"
          />
        </span>
      </td>

      <td>
        <span name="loadTakenInLayer" className="smallInput">
          <NumberFormatText
            value={rowValuesCalc?.loadTakenInLayer?.current}
            decimalScale={2}
            prefix="INF"
          />
        </span>
      </td>

      <td>
        <RemoveButton index={index} />
      </td>
    </tr>
  );
}
